// extracted by mini-css-extract-plugin
export var blue = "_b-f";
export var brand = "_b-b";
export var darkGrey = "_b-e";
export var disabled = "_b-4";
export var disabledSubtle = "_b-5";
export var error = "_b-6";
export var green = "_b-g";
export var grey = "_b-d";
export var icon = "_b-0";
export var inherit = "_b-a";
export var lightGrey = "_b-c";
export var orange = "_b-i";
export var pink = "_b-k";
export var primary = "_b-1";
export var purple = "_b-l";
export var red = "_b-j";
export var secondary = "_b-2";
export var success = "_b-9";
export var tertiary = "_b-3";
export var warning = "_b-7";
export var warningSecondary = "_b-8";
export var white = "_b-m";
export var yellow = "_b-h";